import React from 'react';


const ProfileProgress = ({lines}) => {


    const Line = ({l,r})=><div className={`w-[18px] h-[8px] border border-[#EAEAEA] ${l&&'rounded-l-full border-r-0'}  ${r&&'rounded-r-full border-l-0'} ${!l && !r && 'border-r-0 border-l-0'}  bg-[#1C1C1C]`}/>

    return (
        <div className="w-full  flex flex-row gap-[4px]">
            <Line l={true}/>
            {
                Array.from({length:lines}).map((_,idx) =>(
                    <Line key={idx}/>
                ))
            }
            <Line r={true}/>
        </div>
    );
};

export default ProfileProgress;
